import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

// TODO: - Remove following implementations when the new MWE Popup is implemented https://wienenergie.atlassian.net/browse/IKP-2143.
//       - this Guard
//       - Routes (ROUTE_DATENSCHUTZ, ROUTE_IMPRESSUM) in apps/ikp/src/app/app.routes.ts
//       - Constants (ROUTE_DATENSCHUTZ and ROUTE_IMPRESSUM) in apps/ikp/src/app/app.constants.ts
/**
 * This Guard is a fix for https://wienenergie.atlassian.net/browse/IKP-2138.
 * We cannot change the Cookie Component and the links inside. So we redirect to the target links on wienenergie.at
 */
@Injectable({
  providedIn: 'root',
})
export class CookieRedirectGuard implements CanActivate {
  canActivate(): boolean {
    // Redirects the user to the Wien Energie website with the current path and hash.
    // The hash is needed for the technologie link (https://www.wienenergie.at/datenschutz/#datenschutzerklaerung-wien-energie).
    window.location.href = `https://www.wienenergie.at/${window.location.pathname}${window.location.hash}`;
    return true;
  }
}
